<template>
  <div>
    <custom-actions show-back>
      <el-form ref="form" :model="formData" :rules="rules" class="global-form" label-width="130px">
        <el-row :gutter="20">
          <el-col :span="12"><el-form-item label="询价标题" prop="demandTitle"><el-input v-model="formData.demandTitle" maxlength="200" placeholder="请输入询价标题" /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="询价类型" prop="demandType"><el-select v-model="formData.demandType"><el-option label="暂定价" value="2" /><el-option label="一口价" value="1" /><el-option label="通用" value="3" /></el-select></el-form-item></el-col>
          <el-col :span="12">
            <el-form-item label="采购方" prop="userId">
              <el-select v-model="formData.userId" filterable placeholder="请选择采购方">
                <el-option v-for="item in userList" :key="item.userId" :label="item.userName" :value="item.userId" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12"><el-form-item label="品种规格" prop="specId"><el-input v-model="specName" readonly placeholder="请选择品种规格" @click.native="dialogVisible = true" /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="采购数量" prop="demandQuantity"><el-input-number v-model="formData.demandQuantity" :min="0.001" :precision="3" /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="期望单价"><el-input-number v-model="formData.expectedPrice" :min="0" :precision="3" /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="期望交付日期"><el-date-picker v-model="formData.deliveryDate" value-format="yyyy-MM-dd" type="date" placeholder="请选择交付日期" /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="报价截止时间"><el-date-picker v-model="formData.quoteDeadline" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="请选择报价截止时间" /></el-form-item></el-col>
          <el-col v-if="demandId" :span="12">
            <el-form-item label="询价状态"><el-select v-model="formData.demandStatus"><el-option label="报价中" value="1" /><el-option label="已完成" value="2" /><el-option label="已关闭" value="3" /></el-select></el-form-item>
          </el-col>
          <el-col :span="24"><el-form-item label="询价说明"><el-input v-model="formData.remark" type="textarea" :rows="4" maxlength="1000" show-word-limit /></el-form-item></el-col>
        </el-row>
        <el-form-item><el-button type="primary" @click="submit">保存</el-button><el-button @click="$router.back()">取消</el-button></el-form-item>
      </el-form>
    </custom-actions>
    <SpecChoose :visible.sync="dialogVisible" @select="onSpecSelect" />
  </div>
</template>

<script>
import SpecChoose from '@/components/SpecChoose.vue'

export default {
  name: 'PurchaseDemandAdd',
  components: { SpecChoose },
  data() {
    return {
      dialogVisible: false,
      specName: '',
      userList: [],
      formData: {
        demandId: '',
        demandTitle: '',
        // 通用询价在创建点价单时由采购人员选择具体价格类型。
        demandType: '3',
        userId: '',
        specId: '',
        demandQuantity: undefined,
        expectedPrice: undefined,
        deliveryDate: '',
        quoteDeadline: '',
        remark: '',
        demandStatus: '1'
      },
      rules: {
        demandTitle: [{ required: true, message: '请输入询价标题', trigger: 'blur' }],
        demandType: [{ required: true, message: '请选择询价类型', trigger: 'change' }],
        userId: [{ required: true, message: '请选择采购方', trigger: 'change' }],
        specId: [{ required: true, message: '请选择品种规格', trigger: 'change' }],
        demandQuantity: [{ required: true, message: '请输入采购数量', trigger: 'blur' }]
      }
    }
  },
  computed: {
    demandId() { return this.$route.query.demandId || '' }
  },
  created() {
    this.loadUserList()
    if (this.demandId) this.loadData()
  },
  methods: {
    loadUserList() {
      this.$axios.get(this.$apis.system.selectSysUserByList, { userType: '2,3', yxcQx: '1' }).then(res => { this.userList = res || [] })
    },
    loadData() {
      this.$axios.get(this.$apis.yxcPurchaseDemand.selectYxcPurchaseDemandById, { demandId: this.demandId }).then(res => {
        this.formData = res || this.formData
        this.specName = res.specName || ''
      })
    },
    onSpecSelect(data) {
      this.formData.specId = data.specId
      this.specName = data.specName
      this.dialogVisible = false
      this.$refs.form.validateField('specId')
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        const url = this.demandId ? this.$apis.yxcPurchaseDemand.updateYxcPurchaseDemand : this.$apis.yxcPurchaseDemand.insertYxcPurchaseDemand
        this.$axios.post(url, this.formData).then(() => {
          this.$message.success(this.demandId ? '修改成功' : '发布成功')
          this.$router.back()
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-select,
::v-deep .el-input-number,
::v-deep .el-date-editor { width: 100%; }
</style>
